import BackButton, { BackButtonTemplate } from './BackButton';

export default BackButton;
export { BackButtonTemplate };
